import { Entry } from '../Entry'

export function Entry20240902() {
  return (
    <Entry title="Set 02 2024 - v3.8.2">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16039/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
